module.exports = __webpack_public_path__ + "static/media/fedpa-checkmark.c46a902a.svg";